import {currentCartV2} from '@wix/ecom';
import {mapNullToUndefined} from '../../utils/mapperHelper.utils';

export enum MembershipRedemptionUnit {
  SESSIONS = 'sessions',
  CREDITS = 'credits',
}

const redemptionUnitMap: Record<string, MembershipRedemptionUnit | undefined> = {
  [currentCartV2.RedemptionType.SESSIONS]: MembershipRedemptionUnit.SESSIONS,
  [currentCartV2.RedemptionType.CREDITS]: MembershipRedemptionUnit.CREDITS,
};

export class MembershipModel {
  public name: string;
  public redemptionCost?: number;
  public redemptionUnit?: MembershipRedemptionUnit;

  constructor(params: MembershipModel) {
    this.name = params.name;
    this.redemptionCost = params.redemptionCost;
    this.redemptionUnit = params.redemptionUnit;
  }

  public static fromCartV2(membership?: currentCartV2.V2Membership) {
    if (!membership) {
      return undefined;
    }
    const redemptionCost = mapNullToUndefined(membership.redemptionCost);
    return new MembershipModel({
      name: membership.name?.translated ?? membership.name?.original ?? /* istanbul ignore next */ '',
      redemptionCost,
      redemptionUnit:
        redemptionCost && membership.redemptionType ? redemptionUnitMap[membership.redemptionType] : undefined,
    });
  }
}
